import IncidentReportFormLayout from './form'
import GenericCreateForm from '../common/create'

export default () => <GenericCreateForm formLayoutComponent={<IncidentReportFormLayout />} />
